import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LogLevel, OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { TelemetryService } from './core/services/telemetry.service';
import { ClipboardFeedbackComponent } from './core/components/clipboard-feedback/clipboard-feedback.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ClipboardFeedbackComponent],
    templateUrl: './app.component.html',
    styles: ''
})
export class AppComponent implements OnInit, OnDestroy {
    private _destorying$ = new Subject<void>();

    title = 'OpenFLIS';

    constructor(
        private oidcSecurityService: OidcSecurityService,
        private telemetryService: TelemetryService,
        private router: Router
    ) { }
    
    
    ngOnInit(): void {
        this.telemetryService.captureGoogleAdsAttribution();
        this.telemetryService.captureMetaAdsAttribution();
        this.telemetryService.captureAuthCallbackFailureFromUrl();

        this.oidcSecurityService
            .checkAuth()
            .pipe(takeUntil(this._destorying$))
            .subscribe({
                next: ({ isAuthenticated, userData, accessToken }) => {
                    if (environment.authConfig.logLevel === LogLevel.Debug) {
                        console.log('app authenticated', isAuthenticated);
                        console.log(`Current access token is '${accessToken}'`);
                        console.log('Current user data is', userData);
                    }

                    this.navigateAwayFromCallback(isAuthenticated);
                },
                error: (error) => {
                    console.error('Authentication check failed.', error);
                    this.navigateAwayFromCallback(false);
                }
            });
    }

    ngOnDestroy(): void {
        this._destorying$.next();
        this._destorying$.complete();
    }

    private navigateAwayFromCallback(isAuthenticated: boolean) {
        if (!this.isCallbackRoute()) {
            return;
        }

        const route = isAuthenticated || !this.callbackHasAuthResponse()
            ? '/'
            : '/warn/unauthorized';

        this.router.navigateByUrl(route, { replaceUrl: true });
    }

    private isCallbackRoute(): boolean {
        if (typeof window === 'undefined') {
            return this.router.url.endsWith('/callback');
        }

        return window.location.pathname.endsWith('/callback');
    }

    private callbackHasAuthResponse(): boolean {
        if (typeof window === 'undefined') {
            return false;
        }

        const params = new URLSearchParams(window.location.search);
        return params.has('code') || params.has('state') || params.has('error');
    }
}
